// src/components/controller/ActionButtons.js
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import TooltipWrapper from '../common/TooltipWrapper';
import { ResponsiveTournamentControlContainer, HiddenInput, ActionButtonsContainer, TournamentNameInputOverrides } from '../../styles/controllerPageStyles';
import { SendIcon, HardDriveUploadIcon, HardDriveDownloadIcon, SettingsIcon, EraserIcon, FileTextIcon, HomeIcon, Share2Icon, MonitorPlayIcon, ViewIcon } from '../../styles/iconStyles';

const ActionButtons = ({
  t,
  timerState,
  isReadyEditing,
  rows,
  tournamentName,
  setTournamentName,
  touchStructure,
  handleUpdateStructure,
  handleFileSave,
  fileInputRef,
  handleFileLoad,
  structureActions,
  setModals,
  controllerSettings,
  setViewMode,
  displayUrl,
  navigate,
  setEditingInfoText,
  tournamentDetails,
  canEditColumns,
}) => {

  const loadButtonDisabled = timerState !== 'ready';
  const saveButtonDisabled = rows.length === 0;

  return (
    <ResponsiveTournamentControlContainer>
      <Input value={tournamentName} onChange={(e) => { setTournamentName(e.target.value); touchStructure(); }} placeholder={t('tournament.namePlaceholder')} disabled={timerState !== 'ready'} overrides={TournamentNameInputOverrides} />
      <ActionButtonsContainer>

        <TooltipWrapper tooltipContent={t('tournament.updateStructure')}><Button onClick={handleUpdateStructure} disabled={!isReadyEditing} kind="minimal" shape="square"><SendIcon $size={24} /></Button></TooltipWrapper>
        <TooltipWrapper tooltipContent={t('controller.saveLocal')}><Button onClick={handleFileSave} disabled={saveButtonDisabled} kind="minimal" shape="square"><HardDriveDownloadIcon $size={24} /></Button></TooltipWrapper>
        <TooltipWrapper tooltipContent={t('controller.loadLocal')}><Button onClick={() => fileInputRef.current?.click()} disabled={loadButtonDisabled} kind="minimal" shape="square"><HardDriveUploadIcon $size={24} /></Button></TooltipWrapper>
        <TooltipWrapper tooltipContent={t('structure.initializeStructure')}><Button onClick={() => { if (window.confirm(t('structure.confirmInitializeStructure'))) { structureActions.initializeStructure(); } }} kind="minimal" disabled={!canEditColumns} shape="square"><EraserIcon $size={24} /></Button></TooltipWrapper>
        <TooltipWrapper tooltipContent={t('display.editInfoTooltip')}><Button onClick={() => { setEditingInfoText(tournamentDetails.customInfoText || ''); setModals(m => ({ ...m, info: true })); }} disabled={isReadyEditing} kind="minimal" shape="square" data-testid="btn-info"><FileTextIcon $size={24} /></Button></TooltipWrapper>
        {controllerSettings.isIntegratedViewEnabled
          ? <TooltipWrapper tooltipContent={t('display.toggleDisplayMode')}><Button onClick={() => setViewMode('display')} kind="minimal" shape="square"><ViewIcon $size={24} /></Button></TooltipWrapper>
          : <TooltipWrapper tooltipContent={t('display.openDisplay')}><Button onClick={() => window.open(displayUrl, '_blank')} kind="minimal" shape="square"><MonitorPlayIcon $size={24} /></Button></TooltipWrapper>
        }
        <TooltipWrapper tooltipContent={t('common.settings')}><Button onClick={() => setModals(m => ({ ...m, settings: true }))} kind="minimal" shape="square" data-testid="btn-settings"><SettingsIcon $size={24} /></Button></TooltipWrapper>
        <TooltipWrapper tooltipContent={t('tournament.shareTournament')}><Button onClick={() => setModals(m => ({ ...m, share: true }))} kind="minimal" shape="square" data-testid="btn-share"><Share2Icon $size={24} /></Button></TooltipWrapper>
        <TooltipWrapper tooltipContent={t('common.backToDashboardTooltip')}><Button onClick={() => navigate('/')} disabled={timerState !== 'ready' && timerState !== 'stop'} kind="minimal" shape="square"><HomeIcon $size={24} /></Button></TooltipWrapper>
        <HiddenInput type="file" accept=".yaml,.yml" ref={fileInputRef} onChange={handleFileLoad} />
      </ActionButtonsContainer>
    </ResponsiveTournamentControlContainer>
  );
};

export default ActionButtons;
